import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faSignOut } from '@fortawesome/pro-light-svg-icons'

import { Button, IconWithMenu, Link } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import ImpersonateEntityButton from '@components/ImpersonateEntityButton'
import useAgency, { generateUrls } from '@hooks/useAgency'

const AgenciesTableActions = (props: { agencyId: number }) => {
  const { agencyId } = props

  const { editAgencyUrl } = generateUrls({ id: agencyId })

  const { agency, callbacks: { loginAsAgency } } = useAgency({ id: agencyId })

  return (
    <IconWithMenu
      boxProps={{ position: 'relative' }}
      icon={(
        <Link greyLink>
          <FontAwesomeIcon icon={faCog} />
        </Link>
      )}
      shouldUsePortal
    >
      {/*
       // @ts-expect-error TS2741 */}
      <IconWithMenu.Menu closeOnClick>
        <ImpersonateEntityButton
          as="a"
          // @ts-expect-error TS2322
          callbacks={{ loginAsEntity: loginAsAgency }}
          // @ts-expect-error TS2322
          entity={agency}
          border="none"
          style={{
            fontSize: '12px', width: '100%', justifyContent: 'left',
          }}
          buttonStyle="secondaryUtility"
        >
          Login
        </ImpersonateEntityButton>

        <Button
          // @ts-expect-error TS2322
          as="a"
          border="none"
          buttonStyle="secondaryEdit"
          href={`${editAgencyUrl}?redirect=${generateRedirectUrl()}`}
          icon={<FontAwesomeIcon icon={faSignOut} />}
        >
          Edit Agency
        </Button>
      </IconWithMenu.Menu>
    </IconWithMenu>
  )
}

export default AgenciesTableActions
